import { TMachineTypes } from '~logic/xstate/typings'

//* CONTEXT ---------------------------------------------------------------------------------------
type TBaseContext = {
  containerElementRef?: Nullable<React.RefObject<HTMLDivElement>>
  contentElementRef?: Nullable<React.RefObject<HTMLDivElement>>
  itemContainerElementId?: string
  childElements?: RoA<{
    center: number
    centerScrollValue: number
  }>
  scrollValue: number
  containerWidth: number
  contentWidth: number
}

type TEmptyContext = {
  contentElementRef: undefined
  containerElementRef: undefined
  scrollValue: 0
  containerWidth: 0
  contentWidth: 0
}

type TInitializedContext = TBaseContext & {
  contentElementRef: React.RefObject<HTMLDivElement>
  containerElementRef: React.RefObject<HTMLDivElement>
}

// * STATES ----------------------------------------------------------------------------------------
type TStateContextMap = {
  // the initial state
  init: TEmptyContext
  // the state, in which the component is active and can manage the scroll
  idle: TInitializedContext
  // content should be scrolled to the start of the container
  'idle.start': TInitializedContext & {
    scrollValue: 0
  }
  // content should be scrolled to the end of the container
  'idle.end': TInitializedContext
  // content should be scrolled to some value between the start and the end
  'idle.shifted': TInitializedContext

  // the machine is not active, the content do not overflow the container
  off: TInitializedContext
}

//* EVENTS -----------------------------------------------------------------------------------------
type TCalcDimensionsEvent = {
  type: 'CALC_DIMENSIONS'
}
type TTurnOnEvent = {
  type: 'TURN_ON'
}
type TTurnOffEvent = {
  type: 'TURN_OFF'
}
type TShiftEvent = {
  type: 'SHIFT'
  payload: {
    shiftValue: number
  }
}
type TCenterChildEvent = {
  type: 'CENTER_CHILD'
  payload: {
    childIndex: number
  }
}

type TEvent = TCalcDimensionsEvent | TShiftEvent | TCenterChildEvent | TTurnOnEvent | TTurnOffEvent

// * TAGS ------------------------------------------------------------------------------------
export const STATE_NODE_TAGS = {
  rightShiftPossible: 'rightShiftPossible',
  leftShiftPossible: 'leftShiftPossible',
} as const

type TTag = typeof STATE_NODE_TAGS[keyof typeof STATE_NODE_TAGS]

export type TScrollOverflowMachineTypes = TMachineTypes<
  TBaseContext,
  TStateContextMap,
  TEvent,
  TTag
>
